<template>
  <div style="height: 100%;width: 100%">
    <div class="overflow-hidden" style="height: 100%;width:100%;padding-left: 25px;">
      <!--机柜信息-->
      <div style="padding-top: 15px;font-weight: bold;margin-bottom: 10px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
        <span style="">机柜信息</span>
      </div>
      <el-row class=" h-100 overflow" style="padding-left: 5px;">
        <el-col v-if="!cabinetList || cabinetList.length <= 0">
          <no-data style="margin-top: 15%"></no-data>
        </el-col>
        <el-col :lg="21" :md="23" :sm="21" :xl="21" :xs="21"
                style="margin: 15px 0 20px 0;" v-if="cabinetList.length>0">
          <el-col :lg="6" :md="6" :sm="6" class="largeContent"
                  style="text-align: center;">名称
          </el-col>
          <el-col :lg="6" :md="6" :sm="6" style="text-align: center;">
            <span>实时功率</span>
          </el-col>
          <el-col :lg="6" :md="6" :sm="6" style="text-align: center;">
            <span>额定功率</span>
          </el-col>
          <el-col :lg="6" :md="6" :sm="6" style="text-align: center;">
            <span>差值</span>
          </el-col>
        </el-col>
        <el-col :span="24">
          <vue-seamless-scroll :class-option="classOption" :data="cabinetList"
              @@touchstart.native="openCabinetInfoDetail" style="height: 80%;overflow:hidden;" @click.native="openCabinetInfoDetail">
            <el-col :key="index" :lg="21" :md="23" :sm="21" :xl="21" :xs="21"
                    style="border-bottom: 1px solid rgba(41, 159, 251, .2);margin-top: 15px;overflow-y: auto"
                    v-for="(item,index) in cabinetList" >
              <el-col :lg="6" :md="6" :sm="6" class="largeContent"
                      style="text-align: center;color: #999999">{{ item.name }}
              </el-col>
              <el-col :lg="6" :md="6" :sm="6" style="color: #999999;text-align: center;">
                <span>{{ item.realTimePower }} KW</span>
              </el-col>
              <el-col :lg="6" :md="6" :sm="6" style="color: #999999;text-align: center;">
                <span>{{ item.ratedPower }} KW</span>
              </el-col>
              <el-col :lg="6" :md="6" :sm="6" style="color: #999999;text-align: center;">
                <span :style="{color: item.difference<0?'red':'green'}">{{ item.difference }} KW</span>
              </el-col>
            </el-col>
          </vue-seamless-scroll>
        </el-col>
      </el-row>
      <!--  机柜详情弹框-->
      <cabinetInfoDialog @openCabinetInfoDetail="openCabinetInfoDetail" :cabinetList="cabinetList"
                         :cabinetDialogFlag="cabinetDialogFlag"
                         style="height: 100%;width: 100%;"></cabinetInfoDialog>
    </div>
  </div>

</template>

<script>

import NoData from "@/components/NoData";
import {getPowerBySpaceId} from "@/network/cabinet-manage";
import vueSeamlessScroll from 'vue-seamless-scroll'
import cabinetInfoDialog from '@/components/component/comprehensive_situation/cabinetInfoDialog'

export default {
  name: "cabinetInfo",
  components: {NoData, vueSeamlessScroll, cabinetInfoDialog},
  inject: ['overflow'],
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: 0, //开始无缝滚动的数据量  //this.alarmList.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        // singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      };
    },
  },
  props: {
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.getPowerBySpaceId()
      }
    },
    tagId() {
      this.getPowerBySpaceId()
    },
  },
  data() {
    return {
      cabinetList: [],
      // 机柜信息列表弹窗标识
      cabinetDialogFlag: false
    }
  },
  methods: {
    getPowerBySpaceId() {
      getPowerBySpaceId(this.spaceId).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.cabinetList = res.data
        }
      })
    },
    // 打开机柜详情列表
    openCabinetInfoDetail() {
      this.cabinetDialogFlag = !this.cabinetDialogFlag
    }
  },
  mounted() {
    this.overflow()
    this.getPowerBySpaceId()
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getPowerBySpaceId:6000': this.getPowerBySpaceId})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getPowerBySpaceId')
  }
}
</script>

<style scoped>

</style>
